// test640
(640 && 0);
